import React, { useState, useEffect } from "react";

const PoweredBy = () => {
  const [theme, setTheme] = useState(document.documentElement.getAttribute('data-theme'));

  useEffect(() => {
    // Function to handle attribute changes
    const handleThemeChange = (mutationsList) => {
      for (const mutation of mutationsList) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'data-theme') {
          const newTheme = document.documentElement.getAttribute('data-theme');
          setTheme(newTheme);
          console.log('Theme changed to:', newTheme);
        }
      }
    };

    const observer = new MutationObserver(handleThemeChange);

    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['data-theme'],
    });

    // Cleanup
    return () => observer.disconnect();
  }, []);

  return (
    <div className="poweredBy-container text-center mt-4">
      <p>
        Powered by
        {' '}
        <a href="https://supercheckout.ai/?utm_source=app&utm_medium=link&utm_campaign=checkout" title="SuperCheckout" target="_blank">
          <img src="/supercheckout-logo-icon-192-192.png" className="footer-powered-by-logo" alt="SuperCheckout" />
          {' '}
          SuperCheckout
        </a>
      </p>
      
      <div className="bg-glow-container">
        <div className="bg-glow-child bg-glow-child-1"></div>
        <div className="bg-glow-child bg-glow-child-2"></div>
    </div>
    </div>
  );
};

export default PoweredBy;
